function Wrapper({ children, condition, wrapper }) {
  return condition ? wrapper(children) : children
}

export default Wrapper
